import { anonymousClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/vue';

export const API_URL: string = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:3000';

const TOKEN_KEY = 'eva.auth.token';

export function storedToken(): string {
  try {
    return localStorage.getItem(TOKEN_KEY) ?? '';
  } catch {
    return '';
  }
}

function rememberToken(token: string | null): void {
  if (!token) return;
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    return;
  }
}

export function forgetToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    return;
  }
}

let pending: Promise<boolean> | null = null;

export async function ensureSession(): Promise<boolean> {
  const { data } = await authClient.getSession();
  if (data?.user) return true;

  pending ??= authClient.signIn
    .anonymous()
    .then((result) => Boolean(result.data?.user))
    .catch(() => false)
    .finally(() => {
      pending = null;
    });

  return pending;
}

export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/api/auth',
  plugins: [anonymousClient()],
  fetchOptions: {
    credentials: 'include',
    auth: { type: 'Bearer', token: storedToken },
    onSuccess: (ctx) => {
      rememberToken(ctx.response.headers.get('set-auth-token'));
    },
  },
});
